import { observer } from "mobx-react";
import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Avatar from "../Common/Avatars/Avatar";
import ButtonPrimary from "../Common/Buttons/ButtonPrimary";
import { globalStores } from "../api/globalStores";
import { definitions } from "../api/supabase/client";

export const ChildAvatarDetails = observer(() => {
  const navigate = useNavigate();
  const [avatar, setAvatar] =
    useState<definitions["ChildDetails"]["avatar"]>("BEAR");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateChildAvatar = async () => {
    if (isSubmitting) return; // Prevent double submission
    setIsSubmitting(true);
    
    try {
      await globalStores.childStore.setAvatar(avatar);
      navigate("/parent/flow/referral_getter");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <p className="text-xlarge pl-3 text-center w-full">Pick an Avatar</p>
      <p className="text-large pb-4 pl-3 text-center w-full">
        This will be the display picture for his/her profile
      </p>
      <div className="flex flex-wrap justify-center pb-2 gap-3">
        <div className="w-16 h-16  over:scale-110 cursor-pointer">
          <Avatar
            onClick={() => setAvatar("BEAR")}
            large
            icon={"bear"}
            active={avatar === "BEAR"}
          />
        </div>
        <div className="w-16 h-16 hover:scale-110 cursor-pointer">
          <Avatar
            onClick={() => setAvatar("HELMET")}
            large
            icon={"biker"}
            active={avatar === "HELMET"}
          />
        </div>
        <div className="w-16 h-16 hover:scale-110 cursor-pointer">
          <Avatar
            onClick={() => setAvatar("SPIKY_HAIR")}
            large
            icon={"boy"}
            active={avatar === "SPIKY_HAIR"}
          />
        </div>
        <div className="w-16 h-16 hover:scale-110 cursor-pointer">
          <Avatar
            onClick={() => setAvatar("DINO")}
            large
            icon={"dino"}
            active={avatar === "DINO"}
          />
        </div>
      </div>
      <ButtonPrimary
        onClick={() => {
          if (isSubmitting) return;
          toast.promise(updateChildAvatar(), {
            loading: "Updating Avatar",
            error: (e: any) => e.message,
            success: "Avatar Updated!",
          });
        }}
        disabled={isSubmitting}
      >
        {isSubmitting ? "Selecting..." : "Select"}
      </ButtonPrimary>
      {/* <div className="flex justify-center py-4 px-2">
        <button
          onClick={() => navigate("/parent/flow/child_details")}
          className="text-brij-DarkGrey hover:text-brij-Black"
        >
          BACK
        </button>
      </div> */}
    </>
  );
});
